
import { defineComponent } from 'vue'
import QIcon from 'quasar/src/components/icon/QIcon.js';import QItem from 'quasar/src/components/item/QItem.js';import QItemSection from 'quasar/src/components/item/QItemSection.js';


export default defineComponent({
    components: {
        QIcon,
        QItem, 
        QItemSection,
    },
    props: {
        title: {
            required: true,
            type: String,
        },
        icon: {
            required: true,
            type: String,
        },
        redirectLink: {
            required: true,
            type: String,
        }
    },
    methods: {
        onClick() {
            open(this.redirectLink);
        }
    }
})
